export default "__VITE_ASSET__4b80bc9f__"